module.exports = __webpack_public_path__ + "img/213.121c2cf8.jpg";